import { HomeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { FC } from 'react';

export const UnauthorizedPage: FC = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <h1 className="text-7xl font-extrabold text-orange-500">403</h1>
        <p className="text-2xl font-medium text-gray-800 mt-4">Access Denied</p>
        <p className="text-gray-600 mt-2">
          You don’t have permission to access this page.
        </p>
        <Button
          href="/"
          size="large"
          variant="filled"
          type="primary"
          className="mt-6 font-semibold"
          icon={<HomeOutlined />}
        >
          Go Back Home
        </Button>
      </div>
    </div>
  );
};
